import { useEffect, useMemo, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

import { Container } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';
import { clsx } from '~/styles/utils';
import { removeFormDataFromSession } from '~/utils/form';

import { ForumSidebar } from './components/ForumSidebar';
import { ForumContext } from './ForumLayout.context';
import { contentWrapperFullWidthStyle, contentWrapperStyle, headerPortalStyle, sidebarWrapperStyle, wrapperStyle } from './ForumLayout.css';

export const ForumLayout = () => {
  const [headerPortal, setHeaderPortal] = useState<HTMLDivElement | null>(null);
  const context = useMemo(() => ({ headerPortal }), [headerPortal]);

  const { pathname } = useLocation();

  const showSidebar = pathname === routes.forumTimeline;

  // Clean up the persisted form data on each route change
  useEffect(() => {
    return () => removeFormDataFromSession(routes.forum);
  }, [pathname]);

  return (
    <ForumContext value={context}>
      <div className={headerPortalStyle} ref={setHeaderPortal} />

      <Container className={wrapperStyle}>
        <div className={clsx(contentWrapperStyle, !showSidebar && contentWrapperFullWidthStyle)}>
          <Outlet />
        </div>

        {showSidebar && (
          <div className={sidebarWrapperStyle}>
            <ForumSidebar />
          </div>
        )}
      </Container>
    </ForumContext>
  );
};
